/* eslint-disable react/jsx-no-bind */
import React, { useContext } from 'react';
import './index.scss';
import SYNC_DOUBLE_LINE from '@ifit/react-icons/dist/icons/SYNC_DOUBLE_LINE';
import { scienceBlue, mountainMeadow } from '../../theme';
import Icon from '@ifit/react-icons/dist/components/icon';
import { ThemeContext } from '@ifit/themes/ThemeContext';

interface IProps {
  reload: () => void;
}

const ReloadScrollingSection: React.FC<IProps> = ({ reload }) => {
  const iconSize = 20;

  const { theme } = useContext(ThemeContext);

  const reloadIcon = {
    LIGHT: scienceBlue,
    DARK: mountainMeadow,
    VAULT: scienceBlue,
  }[theme];

  return (
    <div
      className={'failed-load-container'}
      data-testid={'reload-scrolling-section'}
    >
      <div className={'failed-load-text'}>Content failed to load</div>

      <button className={'failed-load-button'} type={'button'} onClick={reload}>
        <Icon
          icon={SYNC_DOUBLE_LINE}
          color={reloadIcon}
          size={iconSize}
          unitSize="px"
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
        />
        <span className={'failed-load-button-text'}>Reload</span>
      </button>
    </div>
  );
};

export default ReloadScrollingSection;
